<div class="flex flex-col">
  <div *ngIf="!managingSatelliteLocation" class="md:mt-2">
    <div class="gap-5 flex justify-between portal-actions">
      <button type="button" *ngIf="!managingSatelliteLocation && canEdit"
        mat-button color="primary" (click)="createSatelliteLocation()">Add a Satellite Location</button>
      <button type="button" *ngIf="!managingSatelliteLocation"
        mat-button color="primary" class="ml-auto" (click)="getSatelliteLocations(!includeArchived)">
        {{includeArchived ? 'Hide Archived' : 'Show Archived'}}
      </button>
    </div>

    <mat-table [dataSource]="satelliteLocationSource" matSort #satelliteLocationSort="matSort" aria-describedby="On-Campus Buildings" class="mat-elevation-z8 portal-responsive-table">
      <ng-container matColumnDef="satelliteId">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Satellite ID</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let building">
          <span class="mobile-label">Satellite ID</span>
          {{ HospitalLicenseId }}-{{ building.satelliteId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="buildingName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Satellite Name</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let building">
          <span class="mobile-label">Satellite Name</span>
          {{ building.buildingName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="archived">
        <mat-header-cell *matHeaderCellDef mat-sort-header=""></mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let building">
          <span class="font-semibold" *ngIf="building.archived">Archived</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="satelliteLocationColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: satelliteLocationColumns" class=""
               [ngClass]="row.archived? 'portal-archived' : ''" (click)="selectSatelliteLocation(row)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectSatelliteLocation(row))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectSatelliteLocation(row))"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" #satelliteLocationPaginator="matPaginator">
    </mat-paginator>
  </div>

   <div class="flex flex-col w-full" *ngIf="managingSatelliteLocation" [@slideRight]>
    <form [formGroup]="satelliteForm" class="flex flex-col w-full gap-4">
      <div class="flex flex-row gap-2 portal-section-grid">
        <div class="flex flex-col w-1/2 gap-2">
          <div class="satellite-location-toolbar">
            <div class="satellite-location-heading">
              <span class="font-semibold" *ngIf="managingSatelliteLocation && !newSatelliteCreated">Managing Location</span>
              <span class="font-semibold" *ngIf="managingSatelliteLocation && newSatelliteCreated">Add a Satellite Location</span>
            </div>
            <div class="satellite-location-actions portal-actions">
              <button type="button" *ngIf="managingSatelliteLocation && satelliteForm.valid && canEdit"
                        mat-button color="primary" (click)="saveSatelliteLocation()">Save</button>
              <button type="button" mat-button color="warn" *ngIf="canEdit"
                        (click)="confirmDelete(satelliteLocation.id)">Delete</button>
              <button type="button" *ngIf="managingSatelliteLocation"
                        mat-button color="warn" (click)="toggleSatelliteForm(false)">Close</button>
              <button type="button" mat-icon-button *ngIf="canEdit"
                        [color]="satelliteLocation.archived ? 'primary' : 'warn'"
                        (click)="archiveSatelliteLocation(satelliteLocation, !satelliteLocation.archived)"
                        [matTooltip]="satelliteLocation.archived ? 'Un-Archive Building' : 'Archive Building'"
                        matTooltipShowDelay="500" matTooltipHideDelay="200">
                  <mat-icon [fontIcon]="satelliteLocation.archived ? 'unarchive' : 'archive'"></mat-icon>
                </button>
            </div>
          </div>

          <div *ngIf="!canEdit" class="flex flex-col gap-2">

            <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid">
              <div class="flex flex-row gap-2 md:w-1/3 portal-detail-row">
                <span class="font-semibold">Building ID:</span>
                <span>{{HospitalLicenseId}}-{{satelliteLocation.satelliteId}}</span>
              </div>

              <div class="flex flex-row gap-2 portal-detail-row">
                <span class="font-semibold">Phone:</span>
                <span>{{satelliteLocation.phone | mask:"000-000-0000"}}</span>
              </div>
            </div>

            <div class="flex flex-row gap-2 md:w-2/3 portal-detail-row">
              <span class="font-semibold">Name of the building:</span>
              <span>{{satelliteLocation.buildingName}}</span>
            </div>
          </div>

          <div *ngIf="canEdit" class="flex flex-col gap-2">
            <div class="flex flex-col md:flex-row md:gap-4 portal-field-grid location-primary-fields">
              <div class="location-id-field">
                <span class="location-id-prefix">{{HospitalLicenseId}}-</span>
                <mat-form-field class="flex-1">
                  <mat-label>Satellite ID</mat-label>
                  <input matInput formControlName="satelliteId" [readonly]="!canEdit">
                  <mat-error *ngIf="satelliteForm.get('satelliteId')?.hasError('required')">
                    A satellite ID is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="location-phone-field">
                <mat-form-field>
                  <mat-label>Phone</mat-label>
                  <input matInput formControlName="phone" mask="000-000-0000" [readonly]="!canEdit">
                  <mat-error *ngIf="satelliteForm.get('phone')?.hasError('required')">
                    Phone number required
                  </mat-error>
                  <mat-error *ngIf="satelliteForm.get('phone')?.hasError('pattern')">
                    Format number as 000-000-0000
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="flex flex-row w-full gap-2 portal-field-grid">
              <mat-form-field class="flex w-full">
                <mat-label>Name of the building</mat-label>
                <input matInput formControlName="buildingName">
                <mat-error *ngIf="satelliteForm.get('buildingName')?.hasError('required')">
                  A building name is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <app-hospital-service-location
            [entityId]="satelliteLocation.id"
            [entityType]="entity"
            [showType]="true"
            [canEdit]="canEdit">
          </app-hospital-service-location>

        </div>

        <div class="flex flex-col w-1/2 gap-4">
          <address [entityId]="satelliteLocation.id"
            [entityType]="sharedService.satelliteLocation"
            [limitEntries]="true"
            [isEditable]="canEdit"
            (reportOutOfState)="updateOutOfState($event)">
          </address>
          <div class="flex flex-col w-full">
            <span class="font-semibold">Documents:</span>
            <document
              [entityId]="satelliteLocation.id"
              [entityType]="sharedService.satelliteLocation"
              [editable]="canEdit"
              [types]="satelliteLocationTypes">
            </document>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
